import {isOffline} from './const';

let protocol = window.location.protocol;

if (protocol === 'file:') {
    protocol = 'https:';
}

const HOST_YIYAN = `${protocol}//yiyanapp.baidu.com`;
// const HOST_UGC = `${window.location.protocol}//prompt-test.now.baidu.com`;
const HOST_UGC = `${protocol}//prompt.baidu.com`;
// et server地址
// const OFFLINE = 'http://newapp-nginx.feature-60109400-417f-457e-8416-a945d4afc9f5.newapp.appspace.baidu.com';
// const OFFLINE = 'http://newapp-nginx.feature-66fd15ec-ec6b-47eb-9228-2ad663afddf4.newapp.appspace.baidu.com';
const OFFLINE = `${protocol}//yiyanapp.baidu.com`;
const COIN_OFFLINE = __COIN_REQ_URL__ ?? HOST_YIYAN;
const UGC_OFFLINE = __UGC_REQ_URL__;

const HOST = isOffline ? OFFLINE : HOST_YIYAN;
// const HOST = 'http://newapp-nginx.feature-72c71c32-3345-4496-8c88-62b8b7f41bdf.newapp.appspace.baidu.com';

const HOST_COMMUNITY = isOffline ? OFFLINE : HOST_YIYAN;
const HOST_CHARACTER = isOffline ? OFFLINE : HOST_YIYAN;
const HOST_COIN = isOffline ? COIN_OFFLINE : HOST_YIYAN;
const HOST_PROMPT_UGC = isOffline ? UGC_OFFLINE : HOST_UGC;
const ASK_API = `${HOST}/chat/completions`;

const YIYAN_ASK_API = `${HOST}/api/yiyan/chat`;
const STOP_ANSWER_API = `${HOST}/chat/completionsStop`;
const CONSUME_API = `${HOST}/api/talk/msg/consume`;
const CHAT_RECOVER_API = `${HOST}/chat/recover`;
const SUGGESTIONS_API = `${HOST}/api/talk/suggestions`;
const FEEDBACK_API = `${HOST}/api/talk/like`;
const HISTORY_API = `${HOST}/api/talk/bot/history`;
const RECENT_HISTORY_API = `${HOST}/api/talk/bot/recentHistory`;
const DELETE_MESSAGE_API = `${HOST}/api/message/record/del`;
const DELETE_BOT_API = `${HOST}/api/bot/del`;
// 未登录的历史记录
const ANONYMOUS_RECENT_HISTORY_API = `${HOST}/api/talk/anonymous/recentHistory`;
const YIYAN_HISTORY_API = `${HOST}/api/yiyan/botHistory`;
const AICENTER_API = `${HOST}/api/robot/inspiration`;
const SHARE_API = `${HOST}/api/share/dtl`;
// chat--获取反馈面板信息
const FEEDBACKINFO_API = `${HOST}/api/feedbackinfo`;
// chat--提交反馈
const FEEDBACK_SUBMIT_API = `${HOST}/api/feedback`;
// prompt详情页 端内
const PROMPTDETAIL_API = `${HOST}/api/inspiration/detail`;
// prompt详情页 端外
const PROMPTDETAILSHARE_API = `${HOST}/api/inspiration/sharedtl`;
// prompt编辑历史
const PROMPTHISTORY_API = `${HOST}/api/inspiration/history`;
// prompt详情 点赞
const PROMPTLIKE_API = `${HOST}/api/inspiration/like`;
// prompt详情 分享点击统计
const PROMPTSHARE_API = `${HOST}/api/prompt/share`;
// 社区详情-端内详情页
const COMMUNITYDETAIL_API = `${HOST_COMMUNITY}/api/us/feed/chat/info`;
// 社区详情-分享落地页
const COMMUNITYDETAILSHARE_API = `${HOST_COMMUNITY}/api/us/feed/chat/infoshare`;
// 社区详情-分享落地页
const COMMUNITYDETAILINNER_API = `${HOST_COMMUNITY}/api/us/feed/inner/chat/info`;
// 社区详情 点赞
const COMMUNITYLIKE_API = `${HOST_COMMUNITY}/api/us/activity/chatLike`;
// 社区详情 关注
const FOLLOWUSER_API = `${HOST_COMMUNITY}/api/us/activity/follow`;
// 社区ai评论详情
const AICOMMENTDETAIL_API = `${HOST_COMMUNITY}/api/us/aicomment/detail`;

const PROMPTLIST_API = `${HOST}/api/inspiration/list`;
const PROMPT_CLICK_API = `${HOST}/api/prompt/click`;

// 多选对话生成分享链接
const CHAT_SHARE_CREATE = `${HOST}/api/share/create`;
// 个人中心-关注列表页
const GET_FOLLOWEE_API = `${HOST}/api/us/activity/followee`;
// 个人中心-粉丝列表页
const GET_FANS_API = `${HOST}/api/us/activity/fans`;
// 个人中心-关注/粉丝列表页点击关注按钮
const POST_FOLLOW_API = `${HOST}/api/us/activity/follow`;
// 上传图片服务
const UPLOAD_SCREENSHOT_API = `${HOST_YIYAN}/talk/api/upload-screenshot`;
const IMG_PROXY_API = `${HOST_YIYAN}/talk/api/img-proxy`;

// 伙伴详情页 - 端内
const CHARACTERINFO_API = `${HOST_CHARACTER}/api/admin/character/info`;
// 伙伴详情页 - 分享页面
const CHARACTERSHAREINFO_API = `${HOST_CHARACTER}/api/admin/character/shareinfo`;

// 伙伴信息
const CHARACTER_INFO = `${HOST}/api/talk/character`;

// 收藏智能体
const COLLECT_CHARACTER_API = `${HOST}/api/character/collect`;

// 获取音乐真正可播地址
const GET_MUSIC_LINK = `${HOST}/api/admin/music/link`;

// 伙伴信息扩展接口
const ADDITIONAL_INFO = `${HOST}/api/talk/character/additionalInfo`;

// prompt信息日志
const PROMPT_INFO = `${HOST}/api/talk/prompt`;

// 欢迎语落pb
const UPLOAD_API = `${HOST}/api/talk/upload`;
// 摇一摇请求
const SHAKE_API = `${HOST}/api/admin/character/shake`;
// 自由订阅引导卡
const FREE_SUBS_CARD = `${HOST}/api/admin/reminder/freeSubscribeCard`;

// 灵感币信息
const COIN_TOTAL_API = `${HOST_COIN}/growth/api/user/coin/total`;
const COIN_VIP_REFUND_API = `${HOST_COIN}/growth/api/coin/single/refund`;
const COIN_INCOME_API = `${HOST_COIN}/growth/api/user/coin/income`;
const COIN_EXPENDITURE_API = `${HOST_COIN}/growth/api/user/coin/expenditure`;
const COIN_INFO_API = `${HOST_COIN}/growth/api/user/coin/info`;
const COIN_TASK_ADD_API = `${HOST_COIN}/growth/api/coin/task/add`;
const COIN_DAY_PAY_COUNTDOWN_API = `${HOST_COIN}/growth/api/user/single/status`;
const COIN_GUIDE_STATUS = `${HOST_COIN}/growth/api/user/guide/status`;

// 知秋云客服
const ZHIQIU_API
    = 'https://zhiqiu.baidu.com/imcswebchat/roulette/in?id=49253&token=j9ql02llcjt84mvr6ponc6hfstp4a6oo&domainID=yiyanapp&type=1';
// 鉴权服务
const AUTH_CHECK_API = `${HOST}/api/auth/check`;

// 用户信心
const USERINFO_API = `${HOST}/api/us/open/user/info`;

// 演唱会
const CONCERT_API = `${HOST}/api/us/open/activity/concertList`;
// 领取券码
const GET_COUPON_CODE = `${HOST}/api/admin/activity/coupon/receive`;
// 会员支付-开通记录明细
const GET_MEMBER_RECORD = `${HOST}/api/uc/member/records`;
// 支付-创建订单
const CREATE_ORDER_API = `${HOST}/api/pay/order/create`;
// 支付-订单列表
const GET_PAY_LIST = `${HOST}/api/pay/order/iosPayAuditList`;
// 会员支付-订单
const GET_GIFT_LIST = `${HOST}/api/pay/giftcard/list`;
// 会员支付-自动续费
const GET_ORDER_AGREEMENT = `${HOST}/api/pay/agreement`;
// 会员页
const MEMBERSKULIST_API = `${HOST}/api/us/member/sku/list`;
// 切题接口
const QUESTION_API = `${HOST}/api/plugin/question/resolve`;
// const QUESTION_API = 'http://songzening01.bcc-gzbh.baidu.com:8090/api/plugin/question/resolve';

// 获数字数字分身+祝福语
const GET_CHAR_BLESSINGS = `${HOST}/api/us/newyear/getCharAndBlessings`;
// 拜年文案提审接口
const SEND_AUDIT = `${HOST}/api/us/newyear/content/audit`;

// prompt ugc提示词编辑页
const PROMPT_UGC_API = `${HOST_PROMPT_UGC}/prompt-creation/app`;

// character ugc 角色编辑页
const CHARACTER_UGC_API = `${HOST_PROMPT_UGC}/prompt-creation/app/character`;
// 上屏检查
const AUTH_SCREEN_API = `${HOST}/api/auth/screen`;

const LITE_CHAT_INFO_API = `${HOST}/api/external/chat/info`;
// 端外h5分享
const GREETING_INFO_API = `${HOST}/api/admin/h5/greeting/info`;
const GREETING_CARD_API = `${HOST}/api/admin/h5/greeting/card`;

// 获取短链
const SHORTENURL_API = `${HOST}/api/admin/tools/shortenUrl`;
// 获取活动详情及动态二维码token
const ACTIVITY_INFO_API = `${HOST}/api/us/open/business/activity/info`;
// 活动详情奖品信息
const ACTIVITY_DETAIL_API = `${HOST}/api/us/open/business/activity/detail`;
// 领取并激活会员体验卡
const ACTIVITY_EXPERIENCE_API = `${HOST}/api/us/business/activity/experienceCard`;

// 礼品卡页
const GIFTSKULIST_API = `${HOST}/api/pay/sku/list`;

// 判断是否展示礼品卡入口
const CARDDISPLAY_API = `${HOST}/api/us/member/card/display`;
// 发现tab照相馆模板
const DISCOVERY_TEMPLATE_API = `${HOST}/api/us/feed/template/box`;
// 照相馆模版详情
const TEMPLATE_INFO_API = `${HOST}/api/us/feed/template/info`;
// 制作写真
const MAKE_PHOTO_API = `${HOST}/api/admin/photo/create`;
// 获取写真/数字形象
const GET_POHOTO_API = `${HOST}/api/admin/photo/list`;
// 设置默认形象
const PHOTO_USE_API = `${HOST}/api/admin/photo/use`;
// 照相馆tab顶部运营位
const PHOTO_BANNER_API = `${HOST}/api/admin/photo/banner`;
const GET_TEMPLATES_API = `${HOST}/api/admin/template/info`;
// AI照相馆生成记录tab配置
const GET_TABS_API = `${HOST}/api/admin/photo/conf`;
// AI照相馆生成记录删除
const DEL_PHOTO_API = `${HOST}/api/admin/photo/delete`;

// 获取语种
const GET_LANGUAGE = `${HOST}/api/admin/vis/getLanguage`;
// 学生裂变端外信息接口
const STUDENTVIPMESSAGE_API = `${HOST}/api/us/open/benefitsCard/mpage`;
// 会员福利卡激活
const BENEFITSCARDACTIVATE_API = `${HOST}/api/us/open/benefitsCard/activate`;
// 会员福利卡领取
const BENEFITSCARDGAIN_API = `${HOST}/api/us/open/benefitsCard/gain`;
// 问答拖放页面
const WEB_QAS = `${HOST}/api/admin/web/qas`;

// 运营活动信息
const ACTICITY_INFO_API = `${HOST}/api/admin/openapi/resource`;
// 运营Tab资源信息
const H5_TAB_RESOURCE_API = `${HOST}/api/admin/h5Tab/resource`;
// 上报运营Tab展示信息
const H5_TAB_SHOW_API = `${HOST}/api/admin/h5Tab/show`;
// 升级引导页资源配置
const UPGRADE_GUIDE_INFO = `${HOST}/api/admin/h5Tab/guide`;

// 拥有记录簿的智能体列表
const CHARACTERLIST_WITH_MEMORY = `${HOST}/api/us/memory/listMemoryBook`;
// 根据智能体 ID 拉取记忆簿列表
const MEMORYLIST_BY_CHARACTERID = `${HOST}/api/us/memory/list`;
// 根据记忆 ID 删除指定记忆
const DELETEMEMORY_BY_CHARACTERID = `${HOST}/api/us/memory/delete`;

// 图创相关接口
// 图创智能体推荐列表
const IMAGE_CREATE_API = `${HOST}/api/admin/imageai/getbot`;
// 图创局部替换自动推荐的tag
const IMAGE_PROMPT_TAGS = `${HOST}/api/admin/imageai/getPrompts`;
// 图创生图
const IMAGE_CREATE = `${HOST}/api/admin/imageai/edit`;
// ai修图添加文字风控
const IMAGE_TEXT_CHECK = `${HOST}/api/admin/imageai/screen`;
// 欢迎语进历史
const WELCOME_IN_HISTORY_API = `${HOST}/api/message/recentBox`;
// 交互类的欢迎语更新历史数据
const UPDATE_WELCOME_HISTORY_API = `${HOST}/api/message/updateRecentBox`;
// 欢迎语点击（消费）接口
const WELCOME_CONSUMED_API = `${HOST}/api/message/recommendCard/click`;
// 欢迎语异步请求接口
const WELCOME_ASYNC_API = `${HOST}/api/admin/character/recommendCard`;

// 完成对话时，查询任务信息，看是否完成
const NEW_USER_TASK_STATUS = `${HOST}/api/us/talkEncourage/taskInfo`;
// 任务总信息
const NEW_USER_TASK_INFO = `${HOST}/api/us/talkEncourage/info`;
// 领取奖励
const NEW_USER_TASK_REWARD = `${HOST}/api/us/talkEncourage/reward`;
// 放弃本次活动
const NEW_USER_TASK_CLOSE = `${HOST}/api/us/talkEncourage/close`;
// 活动邀请信息
const NEW_USER_INVITE_INFO = `${HOST}/api/us/inviteEncourage/info`;
// 邀请奖励信息
const INVITE_USER_REWARD_INFO = `${HOST}/api/us/inviteEncourage/reward`;
// 成长中心等级列表
const GROWTH_CENTER_LEVEL = `${HOST}/api/uc/user/levelInfo`;
// 成长中心详情
const GROWTH_CENTER_INFO = `${HOST}/api/uc/user/home`;
// 成长中心任务列表
const GROWTH_CENTER_TASK = `${HOST}/api/uc/task/list`;
// 成长中心领取任务权益
const GROWTH_CENTER_TASK_SUBMIT = `${HOST}/api/uc/task/submit`;
// 成长中心商城列表
const GROWTH_CENTER_GOODS = `${HOST}/api/uc/goods/list`;
// 获取兑换商城商品列表
const EXCHANGE_PRODUCT_LIST = `${HOST}/api/uc/goods/list`;
// 商品兑换接口
const EXCHANGE_PRODUCT = `${HOST}/api/uc/goods/exchange`;
// 奖品核销
const EXCHANGE_GOODS_CONSUME = `${HOST}/api/uc/goods/consume`;
// 商品兑换记录列表
const EXCHANGE_PRODUCT_RECORDS = `${HOST}/api/uc/goods/exchange/records`;
// 学习强国切片接口
const XUEXI_API = `${HOST}/api/admin/xuexi/original`;

const COMMUNITY_SHARE_INFO = `${HOST}/api/us/feed/agent/shareInfo`;
const REPORT_VISIT_AGENT = `${HOST}/api/us/feed/agent/report`;

// 线索卡提交接口
const POST_CLUE_API = `${HOST}/api/uc/business/clue/submit`;
// 线索卡获取验证码
const SMS_CODE_API = `${HOST}/api/uc/auth/sms/send`;
// 智能体框上引导信息
const INPUT_BOX_GUIDE_API = `${HOST}/api/talk/character/extend`;
// ai修图中间页物料接口
const AIRETOUCH_RESOURCE_API = `${HOST}/api/admin/imageai/resource`;

// 服务订单列表接口
const SERVICE_ORDER_LIST = `${HOST}/api/uc/tporder/list`;
// 服务订单tab分类列表接口
const SERVICE_ORDER_TAB = `${HOST}/api/uc/tporder/tab/list`;
// 早下班活动信息接口
const GET_OFF_WORK_MSG_API = `${HOST}/api/us/open/business/earlykf/home`;
// 早下班风控接口（接昊天镜）
const OFF_WORK_RISK_API = `${HOST}/api/us/open/business/earlykf/risk`;
// 早下班活动任务完成上报
const OFF_WORK_REPORT_API = `${HOST}/api/us/open/business/earlykf/treport`;
// 早下班奖励明细
const OFF_WORK_REWARD_API = `${HOST}/api/us/open/business/earlykf/plist`;

// 记忆时间修改
const FREE_SUBSCRIBE_UPDATE = `${HOST}/api/admin/reminder/freeSubscribeUpdate`;
// 新闻详情接口
const NEWS_LIST_API = `${HOST}/api/admin/reminder/newsContent`;
// 沉浸态分享页面
const FEED_SHARE_API = `${HOST}/api/us/feed/discover/share`;

// 喵喵人相关的接口
// 生成喵喵人视频
const MEOW_GENERATE_API = `${HOST}/api/admin/meow/generate`;
// 查询喵舍的信息
const MEOW_HOUSE_INFO_API = `${HOST}/api/admin/meow/home`;
// 上报用户点击信息
const MEOW_CLICK_API = `${HOST}/api/admin/meow/click`;
// 上报用户删除视频接口
const MEOW_DELETE_API = `${HOST}/api/admin/meow/delete`;
// 重新生成视频接口
const MEOW_RETRY = `${HOST}/api/admin/meow/retry`;

// 主会话吸顶配置接口
const TOP_BAR_API = `${HOST}/api/admin/topBar/getCfg`;
// 内容转文档
const GENERATE_DOCUMENT_API = `${HOST}/api/admin/fileConvert/html`;
// 活动相关接口-cny2025
// 创建视频页面-获取信息接口
const CNY2025_EDITDETAILS = `${HOST}/api/us/business/cny2025/editDetails`;
// 创建视频页面-视频生成接口
const CNY2025_VIDEOCREATE = `${HOST}/api/us/business/cny2025/videoCreate`;
// 创建视频页面-获取音频列表接口
const CNY2025_AUDIOLIST = `${HOST}/api/plugin/open/cny2025/audioList`;
// 创建视频页面-言粒兑换次数
const CNY2025_EXCHANGE = `${HOST}/api/us/business/cny2025/exchange`;
// 主页-模板列表
const CNY_2025_TEMPLATE_LIST = `${HOST}/api/plugin/open/cny2025/templateList`;
// 我的作品-视频列表
const CNY_2025_VIDEO_LIST = `${HOST}/api/plugin/cny2025/videoList`;
// 我的作品-删除
const CNY_2025_DEL_VIDEO = `${HOST}/api/plugin/cny2025/videoDelete`;
// 主页面-助力接口
const CNY_2025_ASSIST = `${HOST}/api/us/business/cny2025/assist`;
// 详情页-视频信息接口
const CNY_2025_VIDEO_INFO = `${HOST}/api/plugin/open/cny2025/videoInfo?id=`;
// 拉新-模板详情
const CNY_2025_TEMPLATE = `${HOST}/api/plugin/open/cny2025/templateInfo?templateId=`;
// 手抄报描述
const HAND_DRAWN_POSTER_DESC = `${HOST}/api/plugin/education/shouchaobao/getDescribe`;
// 获取手抄报
const GET_HAND_DRAWN_POSTER = `${HOST}/api/plugin/education/shouchaobao/syncImageGeneration`;
// 用户提示词改写
const PROMPT_REFINE = `${HOST}/api/plugin/education/shouchaobao/queryGeneration`;
// 蛋仔派对活动
// 活动主页
const EGG_BOY_HOME = `${HOST}/api/uc/activity/eggy/home`;
// 抽奖
const EGG_BOY_DRAW = `${HOST}/api/uc/activity/eggy/draw`;
// 领奖
const EGG_BOY_PICK = `${HOST}/api/uc/activity/eggy/pick`;
// 我的奖品
const EGG_BOY_PRIZE = `${HOST}/api/uc/activity/eggy/prizeList`;
// 助力接口
const EGG_BOY_ASSIST = `${HOST}/api/uc/activity/eggy/assist`;
// 订阅接口
const EGG_BOY_SUBSCRIBE = `${HOST}/api/uc/activity/eggy/subscribe`;

/* 鹅鸭杀活动接口 */
// 活动主页
const GOOSEDUCK_BOY_HOME = `${HOST}/api/uc/activity/gooseDuck/home`;
// 抽奖
const GOOSEDUCK_BOY_DRAW = `${HOST}/api/uc/activity/gooseDuck/draw`;
// 领奖
const GOOSEDUCK_BOY_PICK = `${HOST}/api/uc/activity/gooseDuck/pick`;
// 我的奖品
const GOOSEDUCK_BOY_PRIZE = `${HOST}/api/uc/activity/gooseDuck/prizeList`;
// 助力接口
const GOOSEDUCK_BOY_ASSIST = `${HOST}/api/uc/activity/gooseDuck/assist`;
// 订阅接口
const GOOSEDUCK_BOY_SUBSCRIBE = `${HOST}/api/uc/activity/gooseDuck/subscribe`;

// 用户信息
const OWNER_MSG_LIST_API = `${HOST}/api/uc/privacy/dataList`;
// 清单分类列表
const PRIVACY_TABLIST = `${HOST}/api/uc/privacy/tabList`;

const FREE_VIP_API = `${HOST}/api/us/open/business/freeDay`;

// 投稿激励提报接口
const SUBMIT_INCENTIVE_API = `${HOST}/api/us/feed/topic/submitLink`;
// 活动话题分享
const ACTIVITY_TOPIC_SHARE_API = `${HOST}/api/us/feed/topic/share`;
// 生成视频端外详情
const VIDEO_INFO_API = `${HOST}/api/plugin/open/video/info`;

// 视频模板端外详情
const VIDEO_TEMPLATE_INFO = `${HOST}/api/plugin/video/inspiration/info`;

const LUI_POEM_API = `${HOST}/api/admin/opendata/poemtab`;

const EXPLORE_WORLD_SUG_API = `${HOST}/api/plugin/exploreWorldSug`;

// AI PPT 获取模板列表
const AI_SLIDES_TEMPLATE_API = `${HOST}/api/plugin/aippt/getTplList`;

// AI PPT 获取 Tag 列表
const AI_SLIDES_TAGS_API = `${HOST}/api/plugin/aippt/getTplTags`;

// 上传文件
const AI_SLIDES_UPLOAD_FILE_API = `${HOST}/api/admin/upload`;

// 生成自定义模板
const AI_SLIDES_GENERATE_CUSTOME_TEMPLATE = `${HOST}/api/plugin/aippt/personalTemplate/generate`;
// const AI_SLIDES_GENERATE_CUSTOME_TEMPLATE = 'http://guorenzheng.bcc-gzbh.baidu.com:8090/api/plugin/aippt/personalTemplate/generate';

// 删除自定义模板
const AI_SLIDES_DELETE_CUSTOME_TEMPLATE = `${HOST}/api/plugin/aippt/personalTemplate/delete`;
// const AI_SLIDES_DELETE_CUSTOME_TEMPLATE = 'http://guorenzheng.bcc-gzbh.baidu.com:8090/api/plugin/aippt/personalTemplate/delete';

// 我的 PPT 列表
const GET_MY_SLIDES_API = `${HOST}/api/plugin/aippt/pptList`;

// 我的 PPT 列表
const GET_OUTLINE_API = `${HOST}/api/plugin/aippt/outlineList`;

// 获取大纲详情
const GET_OUTLINE_DETAIL_API = `${HOST}/api/plugin/aippt/outlineDetail`;

const DELETE_OUTLINE_API = `${HOST}/api/plugin/aippt/outlineDel`;

// 清除未读 AI PPT 消息
const CLEAR_UNREAD_MESSAGE_API = `${HOST}/api/talk/msg/consume`;

// PPT 生成消息已读
const SLIDE_READED = `${HOST}/api/plugin/aippt/pptRead`;

// 我的 PPT 列表
const DELETE_SLIDE_API = `${HOST}/api/plugin/aippt/pptDel`;

// 生成 PPT
const GENERATE_SLIDE_API = `${HOST}/api/plugin/aippt/genppt`;

const ADORN_SLIDE_API = `${HOST}/api/plugin/aippt/beautifyStyles`;

// 查询 PPT 生成状态
const GET_SLIDE_STATUS = `${HOST}/api/plugin/aippt/pptStatus`;

// AI PPT 获取模板详情
const AI_SLIDES_TEMPLATE_INFO_API = `${HOST}/api/plugin/aippt/getTplInfo`;

// AI PPT 获取大纲详情
const AI_SLIDES_OUTLINE_DETAIL_API = `${HOST}/api/plugin/aippt/outlineDetail`;

// LITE项目通用 SSE 会话
const LITE_ASK_API = `${HOST}/api/plugin/chat/completions`;

// LITE项目通用 SSE 停止回答
const LITE_STOP_ANSWER_API = `${HOST}/api/plugin/chat/completionsStop`;

// AI PPT 创建大纲 恢复会话
const LITE_OUTLINE_RECOVER_API = `${HOST}/api/plugin/chat/outline/recover`;

// 修改大纲
const AI_SLIDES_UPDATE_OUTLINE_API = `${HOST}/api/plugin/aippt/outlineUpdate`;
// 大纲赞踩
const AI_SLIDES_OUTLINE_FEEDBACK_API = `${HOST}/api/plugin/aippt/outlineVote`;

// 通过activityId获取言粒信息
const COIN_ACTIVITY_EQUITY_API = `${HOST}/api/us/coinActivity/queryEquity`;

// 免费言粒领取
const COIN_ACTIVITY_RECEIVE_API = `${HOST}/api/us/coinActivity/receiveCoin`;

// 获取ai ppt 下载地址
const AI_SLIDES_DOWNLOAD_API = `${HOST}/api/plugin/aippt/download`;

const UPDATE_TEMPLATE_API = `${HOST}/api/plugin/aippt/tplSelect`;
// 成长领取权益卡
const COLLECT_RIGHTS_CARD_API = `${HOST}/api/uc/user/rights/receive`;
// 成长中心等级奖励
const GROWTH_CENTER_USER_INFO = `${HOST}/api/uc/user/info`;
// 邀请好友生成视频端外页面详情接口
const INVITE_VIDEO_SHARE_DETAILS = `${HOST}/api/plugin/open/activity/activityDetails`;
// 邀请好友生成视频 - 视频生成接口
const INVITE_VIDEO_SHARE_CREATE = `${HOST}/api/plugin/activity/videoCreate`;
// 合拍视频 - 获取视频列表
const INVITE_VIDEO_LIST = `${HOST}/api/plugin/activity/videoList`;
// 合拍视频 - 获取视频合集列表
const INVITE_VIDEO_COLLECTION = `${HOST}/api/plugin/activity/videoCollectionList`;
// 合拍视频 - 删除合集
const INVITE_VIDEO_DELETE_COLLECTION = `${HOST}/api/plugin/activity/videoCollectionDelete`;
// 合拍视频 - 删除视频
const INVITE_VIDEO_DELETE_VIDEO = `${HOST}/api/plugin/activity/videoDelete`;

// 获取活动列表
const TOPIC_LIST_API = `${HOST}/api/us/feed/chat/activityList`;
// 生成试卷
const QUIZ_PAPER_GEN_API = `${HOST}/api/plugin/quiz/paperGen`;
// 获取试卷题目
const QUIZ_PAPER_QUESTIONS_API = `${HOST}/api/plugin/open/quiz/paperQuestions`;
// 提交题目答案
const QUIZ_QUESTION_SUBMIT_API = `${HOST}/api/plugin/open/quiz/questionSubmit`;
// 提交试卷 & 获取分析报告
const QUIZ_PAPER_SUBMIT_API = `${HOST}/api/plugin/open/quiz/paperSubmit`;
// 试题列表
const QUIZ_PAPER_LIST_API = `${HOST}/api/plugin/quiz/paperList`;
const SAVE_UID = `${HOST}/api/admin/file/saveUID`;

// 视频创建音频列表
const VIDEO_CREATE_AUDIO_API = `${HOST}/api/plugin/open/video/audio`;
// 视频模板列表
const VIDEO_CREATE_TELPLATE_API = `${HOST}/api/plugin/activity/inspirationList`;
// 视频创建
const VIDEO_CREATE_API = `${HOST}/api/plugin/activity/templateGenerate`;
// 视频做同款查询
const VIDEO_CREATE_DETAIL_API = `${HOST}/api/plugin/activity/activityRecordDetails`;
// 视频详情
const VIDEO_PLAY_DETAIL_API = `${HOST}/api/plugin/open/activity/videoInfo`;
// 视频删除
const VIDEO_PLAY_DELETE_API = `${HOST}/api/plugin/activity/videoDelete`;
// 视频创建活动详情
const VIDEO_CREATE_ACTIVITY_DETAIL_API = `${HOST}/api/plugin/open/activity/growthActivityInfo`;
// 魔法修图，我的创作列表
const MAGIC_RETOUCH_MY_CREATION_LIST = `${HOST}/api/plugin/magicRetouch/myCreationList`;
// 我的创作tag列表
const MY_CREATION_TAG_LIST_API = `${HOST}/api/plugin/multimodal/materials/newtab`;
// 我的创作双列列表
const MY_CREATION_DETAIL_LIST_API = `${HOST}/api/plugin/multimodal/materials/list`;
// 我的创作双列删除
const MY_CREATION_DETAIL_DELETE_API = `${HOST}/api/plugin/multimodal/materials/delete`;
// 获取魔法修图详情
const MAGIC_RETOUCH_DETAIL_API = `${HOST}/api/share/magicImg`;
// 魔法修图删除（根据taskid删除）
const DELETE_CREATED_MAGIC = `${HOST}/api/plugin/magicRetouch/delCreation`;
// 魔法修图删除（根据图片id删除）
const DELETE_MAGIC_BY_RECORDER = `${HOST}/api/plugin/magicRetouch/delPicture`;
// 魔法修图轮训状态
const MAGIC_RETOUCH_STATUS_API = `${HOST}/api/plugin/magicRetouch/myCreationStatus`;
// 魔法修图消除红点
const MAGIC_RETOUCH_REDPOINT_API = `${HOST}/api/plugin/magicRetouch/redPoint/del`;
// 获取简单文创模板列表
const GET_SURE_WRITE_TEMPLATES = `${HOST}/api/plugin/deepWriting/home`;
// 获取简单文创创作列表
const GET_DOC_LIST = `${HOST}/api/plugin/deepWriting/docList`;
// 删除文创作品
const DELETE_DOC = `${HOST}/api/plugin/deepWriting/delete`;
// 标记文创作品已读
const MARK_DOC_READED = `${HOST}/api/plugin/deepWriting/read`;
// 获取简单文创 prompt 风控状态
const GET_PROMPT_RISK_CONTROL_STATUS = `${HOST}/api/plugin/deepWriting/risk`;
// 获取简单文创，在创作中的作品状态
const GET_SURE_WRITE_DOC_STATUS = `${HOST}/api/plugin/deepWriting/getByIds`;
// 学习记录列表
const EDUCATION_STUDY_RECORD_LIST = `${HOST}/api/plugin/question/record/list`;
// 删除学习记录
const DEL_EDUCATION_STUDY_RECORD = `${HOST}/api/plugin/question/record/del`;

const GET_DOWNLOAD_URL = `${HOST}/api/admin/apk/download/url`;

// 错题记录修改学科
const WRONG_BOOK_SUBJECT_ADJUST_API = `${HOST}/api/plugin/question/wrongBook/subjectAdjust`;
// 错题记录删除
const WRONG_BOOK_DELETE_API = `${HOST}/api/plugin/question/wrongBook/delete`;
// 获取学科列表
const GET_SUBJECT_LIST = `${HOST}/api/plugin/open/question/subject/typeList`;
// 获取错题列表
const GET_WRONG_LIST = `${HOST}/api/plugin/question/wrongBook/list`;
// 错题详情
const GET_WRONG_BOOK_DETAIL = `${HOST}/api/plugin/question/wrongBook/info`;
// 新用户引导信息
const NEW_USER_GUIDE_INFO = `${HOST}/api/uc/activity/newUserEncourage/home`;
// AI PPT 输入框上面的选择列表
const AI_SLIDES_TOP_SELECT_LIST = `${HOST}/api/plugin/aippt/getOutlineTags`;
// AI PPT 生成过程
const AI_SLIDES_PREVIEW_API = `${HOST}/api/plugin/aippt/preview`;

// 用增回传
const ADD_TEXT_REPORT = `${HOST}/api/admin/imageai/actionReport`;

// 魔法漫画分享接口
const COMIC_SHARE_API = `${HOST}/api/plugin/open/magicComic/share`;
// 获取漫画列表
const GET_MAGIC_COMIC_LIST = `${HOST}/api/plugin/magicComic/comicList`;
// 获取漫画详情
const GET_MAGIC_COMIC_INFO = `${HOST}/api/plugin/magicComic/comicInfo`;
// 漫画状态查询
const GET_MAGIC_COMIC_GET = `${HOST}/api/plugin/open/magicComic/get`;
// 删除漫画
const DELETE_MAGIC_COMIC = `${HOST}/api/plugin/magicComic/delete`;
// 编辑漫画
const EDIT_MAGIC_COMIC = `${HOST}/api/plugin/magicComic/edit`;
// 重新生成漫画
const RETRY_MAGIC_COMIC = `${HOST}/api/plugin/magicComic/retry`;
// 红点消除
const MAGIC_COMIC_RED_POINT = `${HOST}/api/plugin/magicComic/redPoint/del`;
// 获取社区卡片列表
const GET_COMMUNITY_LIST = `${HOST}/api/us/user/chats`;
// 获取我的智能体列表
const GET_CHARACTER_LIST = `${HOST}/api/us/user/characters`;
// 删除智能体
const DELETE_CHARACTER = `${HOST}/api/admin/character/open/del`;
// 删除社区卡片
const DELETE_COMMUNITY_CARD = `${HOST}/api/us/feed/chat/delete`;
// 2025元旦活动--配置获取
const YUANDAN_GET_CONFIG = `${HOST}/api/plugin/multimodal/yearActivity/configs`;
// 2025元旦活动--生成
const YUANDAN_POST_DENERATE = `${HOST}/api/plugin/multimodal/generate`;
const YUANDAN_GET_RECORD = `${HOST}/api/plugin/multimodal/record/infos`;
const YUANDAN_GET_RECORD_LIST = `${HOST}/api/plugin/multimodal/record/list`;
const YUANDAN_DELETE_RECORD = `${HOST}/api/plugin/multimodal/record/del`;

const CNY_2026_ACTIVITY_INFO = `${HOST}/api/uc/activity/cny26/info`;
const CNY_2026_ACTIVITY_REPORT = `${HOST}/api/uc/activity/cny26/ra`;
const CNY_2026_ACTIVITY_DRAW = `${HOST}/api/uc/activity/cny26/draw`;
const LATEST_VERSION = `${HOST}/api/admin/latest/version`;
// 红包领取
const REDPACKET_CLAIM = `${HOST}/api/uc/redPacket/claim`;
// 预约红包信息
const REDPACKET_BOOKING_STATUS = `${HOST}/api/uc/redPacket/bookingStatus`;
// 预约红包
const REDPACKET_BOOKING = `${HOST}/api/uc/redPacket/booking`;
// 红包收支明细
const ASSET_RECORDS_API = `${HOST}/api/uc/asset/records`;
const MY_ASSET_INFO_API = `${HOST}/api/uc/asset/info`;

// const MY_ASSET_INFO_API = 'http://huzhenjiang.bcc-gzbh.baidu.com:8089/api/uc/asset/info';
const SEND_INVITE_INFO_API = `${HOST}/api/uc/activity/inviteCash/assist`;
const WITHDRAW_CHECK_API = `${HOST}/api/uc/user/withdrawCheck`;
const GET_DU_TOKEN_API = `${HOST}/api/uc/activity/getDuToken`;

export {
    ACTICITY_INFO_API,
    ACTIVITY_DETAIL_API,
    ACTIVITY_EXPERIENCE_API,
    ACTIVITY_INFO_API,
    ACTIVITY_TOPIC_SHARE_API,
    ADD_TEXT_REPORT,
    ADDITIONAL_INFO,
    ADORN_SLIDE_API,
    AI_SLIDES_DELETE_CUSTOME_TEMPLATE,
    AI_SLIDES_DOWNLOAD_API,
    AI_SLIDES_GENERATE_CUSTOME_TEMPLATE,
    AI_SLIDES_OUTLINE_DETAIL_API,
    AI_SLIDES_OUTLINE_FEEDBACK_API,
    AI_SLIDES_PREVIEW_API,
    AI_SLIDES_TAGS_API,
    AI_SLIDES_TEMPLATE_API,
    AI_SLIDES_TEMPLATE_INFO_API,
    AI_SLIDES_TOP_SELECT_LIST,
    AI_SLIDES_UPDATE_OUTLINE_API,
    AI_SLIDES_UPLOAD_FILE_API,
    AICENTER_API,
    AICOMMENTDETAIL_API,
    AIRETOUCH_RESOURCE_API,
    ANONYMOUS_RECENT_HISTORY_API,
    ASK_API,
    ASSET_RECORDS_API,
    AUTH_CHECK_API,
    AUTH_SCREEN_API,
    BENEFITSCARDACTIVATE_API,
    BENEFITSCARDGAIN_API,
    CARDDISPLAY_API,
    CHARACTER_INFO,
    CHARACTER_UGC_API,
    CHARACTERINFO_API,
    CHARACTERLIST_WITH_MEMORY,
    CHARACTERSHAREINFO_API,
    CHAT_RECOVER_API,
    CHAT_SHARE_CREATE,
    CLEAR_UNREAD_MESSAGE_API,
    CNY_2025_ASSIST,
    CNY_2025_DEL_VIDEO,
    CNY_2025_TEMPLATE,
    CNY_2025_TEMPLATE_LIST,
    CNY_2025_VIDEO_INFO,
    CNY_2025_VIDEO_LIST,
    CNY_2026_ACTIVITY_DRAW,
    CNY_2026_ACTIVITY_INFO,
    CNY_2026_ACTIVITY_REPORT,
    CNY2025_AUDIOLIST,
    CNY2025_EDITDETAILS,
    CNY2025_EXCHANGE,
    CNY2025_VIDEOCREATE,
    COIN_ACTIVITY_EQUITY_API,
    COIN_ACTIVITY_RECEIVE_API,
    COIN_DAY_PAY_COUNTDOWN_API,
    COIN_EXPENDITURE_API,
    COIN_GUIDE_STATUS,
    COIN_INCOME_API,
    COIN_INFO_API,
    COIN_TASK_ADD_API,
    COIN_TOTAL_API,
    COIN_VIP_REFUND_API,
    COLLECT_CHARACTER_API,
    COLLECT_RIGHTS_CARD_API,
    COMIC_SHARE_API,
    COMMUNITY_SHARE_INFO,
    COMMUNITYDETAIL_API,
    COMMUNITYDETAILINNER_API,
    COMMUNITYDETAILSHARE_API,
    COMMUNITYLIKE_API,
    CONCERT_API,
    CONSUME_API,
    CREATE_ORDER_API,
    DEL_EDUCATION_STUDY_RECORD,
    DEL_PHOTO_API,
    DELETE_BOT_API,
    DELETE_CHARACTER,
    DELETE_COMMUNITY_CARD,
    DELETE_CREATED_MAGIC,
    DELETE_DOC,
    DELETE_MAGIC_BY_RECORDER,
    DELETE_MAGIC_COMIC,
    DELETE_MESSAGE_API,
    DELETE_OUTLINE_API,
    DELETE_SLIDE_API,
    DELETEMEMORY_BY_CHARACTERID,
    DISCOVERY_TEMPLATE_API,
    EDIT_MAGIC_COMIC,
    EDUCATION_STUDY_RECORD_LIST,
    EGG_BOY_ASSIST,
    EGG_BOY_DRAW,
    EGG_BOY_HOME,
    EGG_BOY_PICK,
    EGG_BOY_PRIZE,
    EGG_BOY_SUBSCRIBE,
    EXCHANGE_GOODS_CONSUME,
    EXCHANGE_PRODUCT,
    EXCHANGE_PRODUCT_LIST,
    EXCHANGE_PRODUCT_RECORDS,
    EXPLORE_WORLD_SUG_API,
    FEED_SHARE_API,
    FEEDBACK_API,
    FEEDBACK_SUBMIT_API,
    FEEDBACKINFO_API,
    FOLLOWUSER_API,
    FREE_SUBS_CARD,
    FREE_SUBSCRIBE_UPDATE,
    FREE_VIP_API,
    GENERATE_DOCUMENT_API,
    GENERATE_SLIDE_API,
    GET_CHAR_BLESSINGS,
    GET_CHARACTER_LIST,
    GET_COMMUNITY_LIST,
    GET_COUPON_CODE,
    GET_DOC_LIST,
    GET_DOWNLOAD_URL,
    GET_DU_TOKEN_API,
    GET_FANS_API,
    GET_FOLLOWEE_API,
    GET_GIFT_LIST,
    GET_HAND_DRAWN_POSTER,
    GET_LANGUAGE,
    GET_MAGIC_COMIC_GET,
    GET_MAGIC_COMIC_INFO,
    GET_MAGIC_COMIC_LIST,
    GET_MEMBER_RECORD,
    GET_MUSIC_LINK,
    GET_MY_SLIDES_API,
    GET_OFF_WORK_MSG_API,
    GET_ORDER_AGREEMENT,
    GET_OUTLINE_API,
    GET_OUTLINE_DETAIL_API,
    GET_PAY_LIST,
    GET_POHOTO_API,
    GET_PROMPT_RISK_CONTROL_STATUS,
    GET_SLIDE_STATUS,
    GET_SUBJECT_LIST,
    GET_SURE_WRITE_DOC_STATUS,
    GET_SURE_WRITE_TEMPLATES,
    GET_TABS_API,
    GET_TEMPLATES_API,
    GET_WRONG_BOOK_DETAIL,
    GET_WRONG_LIST,
    GIFTSKULIST_API,
    GOOSEDUCK_BOY_ASSIST,
    GOOSEDUCK_BOY_DRAW,
    GOOSEDUCK_BOY_HOME,
    GOOSEDUCK_BOY_PICK,
    GOOSEDUCK_BOY_PRIZE,
    GOOSEDUCK_BOY_SUBSCRIBE,
    GREETING_CARD_API,
    GREETING_INFO_API,
    GROWTH_CENTER_GOODS,
    GROWTH_CENTER_INFO,
    GROWTH_CENTER_LEVEL,
    GROWTH_CENTER_TASK,
    GROWTH_CENTER_TASK_SUBMIT,
    GROWTH_CENTER_USER_INFO,
    H5_TAB_RESOURCE_API,
    H5_TAB_SHOW_API,
    HAND_DRAWN_POSTER_DESC,
    HISTORY_API,
    HOST,
    IMAGE_CREATE,
    IMAGE_CREATE_API,
    IMAGE_PROMPT_TAGS,
    IMAGE_TEXT_CHECK,
    IMG_PROXY_API,
    INPUT_BOX_GUIDE_API,
    INVITE_USER_REWARD_INFO,
    INVITE_VIDEO_COLLECTION,
    INVITE_VIDEO_DELETE_COLLECTION,
    INVITE_VIDEO_DELETE_VIDEO,
    INVITE_VIDEO_LIST,
    INVITE_VIDEO_SHARE_CREATE,
    INVITE_VIDEO_SHARE_DETAILS,
    LATEST_VERSION,
    LITE_ASK_API,
    LITE_CHAT_INFO_API,
    LITE_OUTLINE_RECOVER_API,
    LITE_STOP_ANSWER_API,
    LUI_POEM_API,
    MAGIC_COMIC_RED_POINT,
    MAGIC_RETOUCH_DETAIL_API,
    MAGIC_RETOUCH_MY_CREATION_LIST,
    MAGIC_RETOUCH_REDPOINT_API,
    MAGIC_RETOUCH_STATUS_API,
    MAKE_PHOTO_API,
    MARK_DOC_READED,
    MEMBERSKULIST_API,
    MEMORYLIST_BY_CHARACTERID,
    MEOW_CLICK_API,
    MEOW_DELETE_API,
    MEOW_GENERATE_API,
    MEOW_HOUSE_INFO_API,
    MEOW_RETRY,
    MY_ASSET_INFO_API,
    MY_CREATION_DETAIL_DELETE_API,
    MY_CREATION_DETAIL_LIST_API,
    MY_CREATION_TAG_LIST_API,
    NEW_USER_GUIDE_INFO,
    NEW_USER_INVITE_INFO,
    NEW_USER_TASK_CLOSE,
    NEW_USER_TASK_INFO,
    NEW_USER_TASK_REWARD,
    NEW_USER_TASK_STATUS,
    NEWS_LIST_API,
    OFF_WORK_REPORT_API,
    OFF_WORK_REWARD_API,
    OFF_WORK_RISK_API,
    OWNER_MSG_LIST_API,
    PHOTO_BANNER_API,
    PHOTO_USE_API,
    POST_CLUE_API,
    POST_FOLLOW_API,
    PRIVACY_TABLIST,
    PROMPT_CLICK_API,
    PROMPT_INFO,
    PROMPT_REFINE,
    PROMPT_UGC_API,
    PROMPTDETAIL_API,
    PROMPTDETAILSHARE_API,
    PROMPTHISTORY_API,
    PROMPTLIKE_API,
    PROMPTLIST_API,
    PROMPTSHARE_API,
    QUESTION_API,
    QUIZ_PAPER_GEN_API,
    QUIZ_PAPER_LIST_API,
    QUIZ_PAPER_QUESTIONS_API,
    QUIZ_PAPER_SUBMIT_API,
    QUIZ_QUESTION_SUBMIT_API,
    RECENT_HISTORY_API,
    REDPACKET_BOOKING,
    REDPACKET_BOOKING_STATUS,
    REDPACKET_CLAIM,
    REPORT_VISIT_AGENT,
    RETRY_MAGIC_COMIC,
    SAVE_UID,
    SEND_AUDIT,
    SEND_INVITE_INFO_API,
    SERVICE_ORDER_LIST,
    SERVICE_ORDER_TAB,
    SHAKE_API,
    SHARE_API,
    SHORTENURL_API,
    SLIDE_READED,
    SMS_CODE_API,
    STOP_ANSWER_API,
    STUDENTVIPMESSAGE_API,
    SUBMIT_INCENTIVE_API,
    SUGGESTIONS_API,
    TEMPLATE_INFO_API,
    TOP_BAR_API,
    TOPIC_LIST_API,
    UPDATE_TEMPLATE_API,
    UPDATE_WELCOME_HISTORY_API,
    UPGRADE_GUIDE_INFO,
    UPLOAD_API,
    UPLOAD_SCREENSHOT_API,
    USERINFO_API,
    VIDEO_CREATE_ACTIVITY_DETAIL_API,
    VIDEO_CREATE_API,
    VIDEO_CREATE_AUDIO_API,
    VIDEO_CREATE_DETAIL_API,
    VIDEO_CREATE_TELPLATE_API,
    VIDEO_INFO_API,
    VIDEO_PLAY_DELETE_API,
    VIDEO_PLAY_DETAIL_API,
    VIDEO_TEMPLATE_INFO,
    WEB_QAS,
    WELCOME_ASYNC_API,
    WELCOME_CONSUMED_API,
    WELCOME_IN_HISTORY_API,
    WITHDRAW_CHECK_API,
    WRONG_BOOK_DELETE_API,
    WRONG_BOOK_SUBJECT_ADJUST_API,
    XUEXI_API,
    YIYAN_ASK_API,
    YIYAN_HISTORY_API,
    YUANDAN_DELETE_RECORD,
    YUANDAN_GET_CONFIG,
    YUANDAN_GET_RECORD,
    YUANDAN_GET_RECORD_LIST,
    YUANDAN_POST_DENERATE,
    ZHIQIU_API,
};
